import addMount from "../../core/addMount";
import Material from "./material.entry";

addMount({ appName: "material", app: Material });
